import React, { Component } from 'react';
import './BulkFileFormatDetails.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Nav, NavLink, NavItem, Alert, Row, Col, Table } from 'reactstrap';
import BackButtonComponent from "../backButtonComponent/BackButtonComponent";
import CSVFileFormatDetails from "./CSVFileFormatDetails/CSVFileFormatDetails.container";
import XMLFileFormatDetails from "./XMLFileFormatDetails/XMLFileFormatDetails.container";

const AVAILABLE_FILE_FORMAT_PAGES = {
    CSV_FILE_FORMAT_PAGE: "csv_file_format_page",
    XML_FILE_FORMAT_PAGE: "xml_file_format_page"
};

class BulkFileFormatDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE
        };
    }

    componentWillMount() {
        this.props.onMount();
    }

    render() {
        if (_.isNil(this.props.langs) || _.isNil(this.props.levels)) {
            return null;
        }
        return (
            <div className='bulk-file-format-details-container'>
                <BackButtonComponent path="/bulk-accreditations-upload" label={_.get(this.props.translation, 'bulk_file_format_details.back_button')}/>
                <h3 className="text-center">{_.get(this.props.translation, 'bulk_upload.file_format_info_label')}</h3>
                <Nav pills className="bulk-file-format-details-nav">
                    <NavItem>
                        <NavLink href="#"
                                 onClick={this.handleChangePage(AVAILABLE_FILE_FORMAT_PAGES.CSV_FILE_FORMAT_PAGE)}
                                 active={this.state.currentPage === AVAILABLE_FILE_FORMAT_PAGES.CSV_FILE_FORMAT_PAGE}>
                            {_.get(this.props.translation, 'bulk_file_format_details.csv_file_format_label')}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink href="#"
                                 onClick={this.handleChangePage(AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE)}
                                 active={this.state.currentPage === AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE}>
                            {_.get(this.props.translation, 'bulk_file_format_details.xml_file_format_label')}
                        </NavLink>
                    </NavItem>
                </Nav>
                <Alert
                color="warning">{_.get(this.props.translation, 'bulk_file_format_details.liaise_it_staff')}</Alert>
                {this.renderCurrentPage()}
                <Row className="bulk-csv-file-format-levels-titles-container">
                    <Col>
                        <h5>{_.get(this.props.translation, 'bulk_file_format_details.levels_label')}</h5>
                        {this.renderLevelsCodesTable()}
                    </Col>
                    <Col>
                        <h5>{_.get(this.props.translation, 'bulk_file_format_details.titles_label')}</h5>
                        {this.renderAdditionalTitlesTable()}
                    </Col>
                </Row>
            </div>
        );
    }

    renderCurrentPage = () => {
        switch (this.state.currentPage) {
            case AVAILABLE_FILE_FORMAT_PAGES.CSV_FILE_FORMAT_PAGE:
                return <CSVFileFormatDetails/>;
            case AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE:
                return <XMLFileFormatDetails/>;
            default:
                return null;
        }
    };



    renderLevelsCodesTable = () => {
        return (
            <Table bordered>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.code_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.mean_label')}</th>
                </tr>
                </thead>
                <tbody>
                {this.renderLevelsData()}
                </tbody>
            </Table>
        )
    };

    renderAdditionalTitlesTable = () => {
        return (
            <Table bordered>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.code_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation.language_input_placeholder')}</th>
                </tr>
                </thead>
                <tbody>
                {this.renderLangsData()}
                </tbody>
            </Table>
        )
    };


    renderLangsData = () => {
        return _.map(this.props.langs, (lang, id) => (
            <tr key={id}>
                <td>{lang}</td>
                <td>{_.get(this.props.translation, 'langs.' + lang)}</td>
            </tr>
        ));
    };

    renderLevelsData = () => {
        return _.map(this.props.levels, (level, id) => (
            <tr key={id}>
                <td>{level}</td>
                <td>{_.get(this.props.translation, 'levels.' + level)}</td>
            </tr>
        ));
    };


    handleChangePage = (page) => () => {
        this.setState({currentPage: page});
    }
}

BulkFileFormatDetails.propTypes = {
    levels: PropTypes.array,
    langs: PropTypes.array,
    onMount: PropTypes.func.isRequired,
    translation: PropTypes.object.isRequired
};

export default BulkFileFormatDetails;



// WEBPACK FOOTER //
// ./src/components/commonComponents/bulkFileFormatDetails/BulkFileFormatDetails.js